import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import './css/header.css';

class Header extends Component {
	constructor(props) {
		super(props);
		this.parentContext = props.ctx;
		this.changeLocale = this.changeLocale.bind(this);
		this.state = {
			menuInitialPosition	: "true",
			ajaxLoadingState	: ""
		}
		this.doLogout = this.doLogout.bind(this);
	}
	componentDidMount() {
	}

	componentWillUnmount() {
	}

	changeLocale(e) {
		var l = window.locale.toLowerCase();
		var p = window.location.pathname.toLowerCase();
		var newP;
		//console.log("locale: " + l);
		//console.log("pathname: " + p);
		if (l === "fr") {
			newP = p.replace("-fr", "-en");
			if (p === newP) newP += "-en";
			window.location.pathname = newP;
		} else {
			 newP = p.replace("-en", "-fr");
			if (p === newP) newP += "-fr";
			window.location.pathname = newP;
		};
	}

	generateUrl(pageName) {
		var url = pageName + "-" + window.locale + (window.optaToken ? "?ol=" + window.optaToken : "") + (window.optaAdminToken ? "?oa=" + window.optaAdminToken : "");
		return url;
	}

	toggleMenu(isOpen, evt) {
		if (isOpen){
			this.setState({ menuInitialPosition: "false" });
		}
		else
		{
			this.setState({ menuInitialPosition: "true" })
		}
	}

	doLogout(that){
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function() {
			if (this.readyState === 4){
				that.setState({ajaxLoadingState:""});
				if (this.status === 200) {
					//console.log("Logout successful.");
				} else {
					//console.log("Logged out, but with error.");
				}
				//console.log("window.optaToken='"+window.optaToken+"'");
				//console.log("window.optaAdminToken='"+window.optaAdminToken+"'");

				if ( window.optaToken !== ""){
					//lessee logging out
					window.optaToken = "";
					window.location.href = that.generateUrl("landing"); //
				} else {
					window.optaAdminToken = "";
					window.location.href = that.generateUrl("admin"); //
				}
			}
		}
		var formData = new FormData();
		formData.append('optatoken', window.optaToken + window.optaAdminToken);

		xhr.open('post', window.AppConfig["url-logout"], true);
		this.setState({ajaxLoadingState:"loading"});
		xhr.send( formData );
	}

	doDetailPage(){
		//console.log("DoDetailPage() '" + window.location.pathname +"'");
		var pathname = window.location.pathname.toLowerCase();
		if (pathname === '/') return false;
		if (window.optaAdminToken !== '') {
			//console.log("optaAdminToken");
			if (!pathname.match(/\/adminlanding/gi))
				window.location.href = this.generateUrl("admin");
		} else {
			//console.log("optaToken");
			if (!pathname.toLowerCase().match(/\/landing/gi))
				window.location.href = this.generateUrl("lessee");
		}
	}

	render() {
		var that = this; //remember this reference for XHR 
		return (
			<div id="header-container">
				<div className={"ajax-spinner-lightbox " + this.state.ajaxLoadingState } />
				<div className="header-logo-l" onClick={(e) => {
					//console.log("go home - logo");
					this.doDetailPage();
				}} />
				<div className="header-text" onClick={(e) => {
					//console.log("go home - text");
					this.doDetailPage();
				}}>
					{window.l10n[window.locale]["landing.insurance"]}
					<span>
						{window.l10n[window.locale]["landing.onfile"]}
					</span>
				</div>
				<ul className="nav-links">
					<li onClick={(e) => {
						//console.log("faqs");
						window.location.href = this.generateUrl("faqs");
					}}>
						{window.l10n[window.locale]["landing.faqs"]}
					</li>
					<li onClick={(e) => {
						//console.log("privacy policy");
						window.location.href = this.generateUrl("privacy");
					}}>
						{window.l10n[window.locale]["landing.privacypolicy"]}
					</li>
					<li onClick={(e) => {
						//console.log("contact us");
						window.location.href = this.generateUrl("contactus");
					}}>
						{window.l10n[window.locale]["landing.contactus"]}
					</li>
					{ 
					(this.props.ctx.state.isLoggedIn || this.props.ctx.state.isAdminLoggedIn) &&
						<li onClick={(e) => {
							//console.log("logout");
							this.doLogout(that);
						}}>
							{window.l10n[window.locale]["landing.logout"]}
						</li>
					}
					<li><button onClick={this.changeLocale}>
						{window.l10n[window.locale]["landing.language"]}
					</button></li>
				</ul>

				<Dropdown id="nav" pullRight onToggle={(e, isOpen, evt) => this.toggleMenu(e, isOpen, evt)} bsStyle="nav-links-mobile">
					<Dropdown.Toggle className="toggle-button" noCaret>
						<div className="hamburger-region">
							<div className="hamburger-icon"></div>
							<div className="hamburger-icon"></div>
							<div className="hamburger-icon"></div>
						</div>
					</Dropdown.Toggle>
					<Dropdown.Menu initial={this.state.menuInitialPosition}>
						<MenuItem className="menu-item" onSelect={(e) => {
							//console.log("faqs");
							window.location.href = this.generateUrl("faqs");
						}}>
							{window.l10n[window.locale]["landing.faqs"]}
						</MenuItem>
						<MenuItem className="menu-item" onSelect={(e) => {
							//console.log("privacy policy");
							window.location.href = this.generateUrl("privacy");
						}}>
							{window.l10n[window.locale]["landing.privacypolicy"]}
						</MenuItem>
						<MenuItem className="menu-item" onSelect={(e) => {
							//console.log("contact us");
							window.location.href = this.generateUrl("contactus");
						}}>
							{window.l10n[window.locale]["landing.contactus"]}
						</MenuItem>
						{(this.props.ctx.state.isLoggedIn || this.props.ctx.state.isAdminLoggedIn) &&
							<MenuItem className="menu-item" onSelect={(e) => {
								//console.log("logout");
								this.doLogout(this);
								//window.location.href = this.generateUrl("landing");
							}}>
								{window.l10n[window.locale]["landing.logout"]}
							</MenuItem>
						}
						<MenuItem className="menu-item" onSelect={this.changeLocale}>
							{window.l10n[window.locale]["landing.languagefull"]}
						</MenuItem>
					</Dropdown.Menu>
				</Dropdown>

			</div>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js